import React from "react";
import { useState } from "react";
import { useFirebase } from "../providers/firebase";
import {useAuthentication} from "../providers/authentication";
import LabPopUpModal from "../components/LabPopUpModal";

const LabFacility = () => {
  const { labFacility, addLabPhoto, removeLabPhoto, editPeople, editLabPhoto} = useFirebase();
  const {user} = useAuthentication();

  const [isModalVisible, setModalVisible] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");
  const [uploadedImage, setUploadedImage] = useState(null);

  const { uploadImage, addPhoto } = useFirebase();
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [imageCategory, setImageCategory] = useState(null);
  const [imgIdx, setImgIdx] = useState(null);

  const handleFileChange = (event, key) => {
    setSelectedFile(event.target.files[0]);
    setImageCategory(key.id);
  };

  const handleEdit = (data, idx, key) => {
    setImgIdx(idx);
    setImageCategory(key);
    console.log(idx, key);
    setModalVisible(true);
    setDefaultValue(data);
  };

  const handleAdd = (key) => {
    setDefaultValue("");
    setUploadedImage(null);
    setModalVisible(true);
    setImageCategory(key);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  const handleSubmit = (value) => {
    setUploading(true);
    if (uploadedImage) {
      uploadImage(uploadedImage).then((imageUrl) => {
        value.imageUrl = imageUrl;
       finalizeSubmit(value);
      });
    } else {
      finalizeSubmit(value);
    }
  };

  const finalizeSubmit = async (value) => {
    if (defaultValue) {
      await editLabPhoto(value, imgIdx).then(() => {
        window.location.reload();
      });
      setUploading(false);
      setImageCategory(null);
      setImgIdx(null);
    } else {
      setImageCategory(null);
      await addLabPhoto(value).then(() => window.location.reload());
      setUploading(false);
    }
    setModalVisible(false);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setUploadedImage(file);
  };

  const handleRemove = (idx, key_id) => {
    setImageCategory(null);
    removeLabPhoto(idx, key_id).then(() => window.location.reload());
  };

  return (
    <div className="lab-container">
      <div className="lab-page-container">
        <div className="lab-heading">Laboratory Facilities</div>
        <div className="sections">
          {labFacility ? (
            <>
              {labFacility.map((key, index) => {
                return (
                  <div key={index} className="section">
                    <h1>{key.subtitle} 
                      {user && (
                        <button onClick={() => handleAdd(key.id)}>Add an image</button>
                      )}
                    </h1>
                    <div className="cards">
                      {key.description ? (
                        <>
                          {key.description.map((card, idx) => {
                            return (
                              <div key={idx} className="card">
                                <img src={key.links[idx]} alt="" />
                                <h2>{key.description[idx]}</h2>
                                {user && <button onClick = {() => handleRemove(idx, key.id)}>Remove</button>}
                                {user && <button onClick = {(e) => handleEdit(e, idx, key.id)}>Edit</button>}
                              </div>
                            );
                          })}
                        </>
                      ) : (
                          ""
                        )}
                    </div>
                  </div>
                );
              })}{" "}
            </>
          ) : (
              ""
            )}
        </div>
        <LabPopUpModal
          show={isModalVisible}
          onClose={handleCloseModal}
          onSubmit={handleSubmit}
          defaultValue={defaultValue}
          onImageChange={handleImageChange}
          imageCategory={imageCategory}
          isUploading={uploading}
        />
        <div className="copyright-bar">
          (c) All Rights Reserved by VSIMA Lab, SECS, IIT Bhubaneswar, 2024
        </div>
      </div>
    </div>
  );
};

export default LabFacility;